


































































import {
  computed,
  defineComponent,
  ref,
  isRef,
  watch,
  PropType,
  Ref,
} from '@nuxtjs/composition-api'
import { SelectOption } from '@/contracts/FormInput'
import Multiselect from '@/components/Inputs/vue-multiselect/VueMultiselect.vue'

export default defineComponent({
  name: 'InputSelect',
  components: {
    Multiselect,
  },
  model: {
    prop: 'value',
    event: 'input-change',
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Object],
      default: '',
    },
    noResultText: {
      type: String,
      default: 'Ничего не найдено',
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, Boolean],
      default: false,
    },
    selectOptions: {
      type: [Array as PropType<SelectOption[] | Ref<SelectOption[]>>, Object],
      default: () => [],
    },
    useBorder: {
      type: Boolean,
      default: false,
    },
    returnOptionValue: {
      type: Boolean,
      default: false,
    },
    validateSelect: {
      type: Function as PropType<(option: any, value: any) => boolean>,
      default: (option: SelectOption, value: SelectOption | string) => {
        if (!value) return false
        if (typeof value === 'string') return (option && option.value) === value
        return (option && option.value) === value.value
      },
    },
    disabledChoose: {
      type: Boolean,
      default: false,
    },
    styleType: {
      default: '',
    },
    isNewStyle: {
      default: false,
    },
  },
  setup(props, { emit }) {
    const isFocused = ref(false)

    const options = computed(() =>
      isRef(props.selectOptions)
        ? props.selectOptions.value
        : props.selectOptions
    )

    const clear = () => {
      emit('clear')
    }

    const getValue = computed(() => {
      return options.value?.find((item) =>
        props.validateSelect(item, props.value)
      )
    })

    watch(isFocused, () => {
      if (isFocused) emit('focused')
    })

    const onSelectChange = (option: SelectOption): void => {
      emit('input-change', props.returnOptionValue ? option.value : option)
    }

    const onSearchChange = (search: string): void => {
      emit('search', search)
    }

    return {
      options,
      getValue,
      clear,
      isFocused,
      onSelectChange,
      onSearchChange,
    }
  },
})
